import axios from "axios";

class playerFunctions{
	constructor(){
		this.feedFmPlayer = window['feedFmPlayer'];
		this.isPlayedAudio = false;
		this.feedFmPlayer.setMuted(false);
		this.volume = JSON.parse(localStorage.getItem('userData')).sessionData.ondemandId ? (JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c : 25) : (JSON.parse(localStorage.getItem('userData')).userType === 2 ? (JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.memberFeedFmVolumeD2c : 25) : (JSON.parse(localStorage.getItem('userData')).default.instructorFeedFmVolumeD2c ? JSON.parse(localStorage.getItem('userData')).default.instructorFeedFmVolumeD2c : 25));
		this.feedFmPlayer.speaker.setVolume(this.volume);
		this.allStations = {};
		this.stationsArray = [];
		this.defaultStation = 0;
		this.getAllStations();
		
		var mainThisf = this;
		this.feedFmPlayer.on('all', function(event) {
			if ( event == "play-started" || event == "play-resumed" )
				{
					var array = Array.prototype.splice.call(arguments, 1);
					var artistName = array[0].audio_file.artist.name;
					var songName = array[0].audio_file.track.title;
					var albumName = array[0].audio_file.release.title;
					
					if ( window['setSongArtist'] ) { window['setSongArtist'](artistName); }
					if ( window['setSongName'] ) { window['setSongName'](songName); }
					if ( window['setSongAlbum'] ) { window['setSongAlbum'](albumName); }
				}
			
			if ( event == 'stations' )
				{
					mainThisf.getAllStations();
				}
		});
		window['stopPlayer'] = this.stopPlayer;
	}
	
	playPlayer(stationId, name){
		
		let id = 0;
		for ( var i = 0; i < this.stationsArray.length; i++ )
			{
				let currentStation = this.stationsArray[i];
				if ( currentStation['name'] == name )
					{
						id = parseInt(currentStation['id']);
					}
				
			}
		
		if (!id)
			{
				id = this.defaultStation;
			}			
			
		this.feedFmPlayer.speaker.setVolume(this.volume);
		this.feedFmPlayer.setStationId(id);
		this.feedFmPlayer.play();
		this.isPlayedAudio = true;
		if ( window['checkIsMuted'] ) { window['checkIsMuted']("-"); }
	}
	
	stopPlayer(){
		this.feedFmPlayer.pause();
		this.isPlayedAudio = false;
		
		if ( window['setSongArtist'] ) { window['setSongArtist']("-"); }
		if ( window['setSongName'] ) { window['setSongName']("-"); }
		if ( window['setSongAlbum'] ) { window['setSongAlbum']("-"); }
	}
	
	setMuted(bool){
		this.feedFmPlayer.setMuted(bool);
	}
	
	changeVolume(vol){
		this.feedFmPlayer.speaker.setVolume(vol);
		this.volume = vol;
	}
	
	getAllStations(){
		if ( this.feedFmPlayer && this.feedFmPlayer._stations )
			{
				console.log('using JS SDK FeedFM');
				var stations = this.feedFmPlayer._stations;
				var stationsArray2 = [];
				for ( var st of stations )
					{
						if ( this.defaultStation == 0 ) { this.defaultStation = st['id']; }
						
						this.allStations[st['id']] = st;
						stationsArray2.push(st);
					}
				this.stationsArray = stationsArray2;
			}
		else
			{
				console.log('using API FeedFM');
				var authToken = btoa('1fb8e0b8cda0823ce94281a62f1e6c083871ddbd'+':'+'ced9e14c9c421968d7740a85977e89412938cc9d');
				axios.defaults.headers.common['Authorization'] = "Basic "+authToken;
				axios.post("https://feed.fm/api/v2/session").then(res =>{
					var stations = res.data.stations;
					var stationsArray2 = [];
					for ( var st of stations )
						{
							if ( this.defaultStation == 0 ) { this.defaultStation = st['id']; }
							
							this.allStations[st['id']] = st;
							stationsArray2.push(st);
						}
					this.stationsArray = stationsArray2;
				}).catch(err =>{ });
			}
		
		console.log('Found stations', this.stationsArray);
	}
}

export default playerFunctions;